export const timeRangeContextKey = { key: Symbol() };
